/**
 * KeypadContainerComponent
 * this component displays the list of key pad buttons
 * and emits up one level their data when they are clicked
 */
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

import { KeypadAction, KeypadButtonAction } from '../classes/KeyPad.enums';
import { KeypadConfigType } from '../../../interfaces';

import { E2E_ATTRIBUTES } from '@shared/types/enums/e2e-attributes.enum';

import type { KeypadButton, KeypadEvent } from '../classes/KeyPad.type';

@Component({
  selector: 'keypad-container',
  styleUrls: ['./keypad-container.component.scss'],
  templateUrl: './keypad-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KeypadContainerComponent {
  @HostBinding('attr.e2e-attr')
  public e2eAttr: string = E2E_ATTRIBUTES.KEY_PAD_CONTAINER;

  @Input() public keypadType: KeypadConfigType;
  @Input() public buttons: KeypadButton[];
  @Output() public push: EventEmitter<KeypadEvent> = new EventEmitter();

  /**
   * onKeyPadButton: emits a button object
   * @param keyPadButton { KeypadButton } key pad button object.
   */
  public onKeypadButton(keyPadButton: KeypadButton): void {
    if (keyPadButton.action === KeypadButtonAction.BLANK) {
      return;
    }

    this.push.emit({
      action: KeypadAction.PUSH,
      payload: keyPadButton.value,
    });
  }

  /**
   * isActive: adds/subtracts a class onto keyPadContainer
   * to allow/disallow :active css
   */
  public isActive(): boolean {
    const secureTypes = [KeypadConfigType.PIN];
    return !secureTypes.some(
      (secureType: KeypadConfigType) => secureType === this.keypadType,
    );
  }
}
